// extracted by mini-css-extract-plugin
export default {"square":"spaceAssignmentSelect_square__7uxVz","employees_list":"spaceAssignmentSelect_employees_list__jVdW0"};